/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Search_PlaceholderInputs */

const en_help_search_placeholder = /** @type {(inputs: Help_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search, e.g. invite a client`)
};

const pl_help_search_placeholder = /** @type {(inputs: Help_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj, np. zaproszenie podopiecznego`)
};

/**
* | output |
* | --- |
* | "Search, e.g. invite a client" |
*
* @param {Help_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_search_placeholder = /** @type {((inputs?: Help_Search_PlaceholderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Search_PlaceholderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_search_placeholder(inputs)
	return en_help_search_placeholder(inputs)
});